import { styled } from 'styled-components';
import { CSSProperties } from 'react';

interface PaddingSpanProps {
  width?: CSSProperties['width'];
}

export const PaddingSpan = styled.span<PaddingSpanProps>`
  width: ${p => p.width ?? '0.7rem'};
  min-width: 0.7rem;
  margin-right: 0.25rem;
  height: 100%;
`;
